

import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";

import ToastService from "../../services/toastService";
import {
    apiService,
    useApiRequestMutation
} from "../../services/apiService";

const useAdminLogout = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [apiRequest, { isLoading }] =
        useApiRequestMutation();

    const Logout = useCallback(async () => {

        try {

            // Logout confirmation
            const result = await Swal.fire({
                title: "Are you sure you want to logout?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Logout",
                cancelButtonText: "Cancel",
                confirmButtonColor: "#d32f2f",
                cancelButtonColor: "#757575",
                background: "#fdfdfd",
                color: "#212121",
                iconColor: "#d32f2f",
                allowOutsideClick: false,
                allowEscapeKey: false,
                reverseButtons: true,
            });

            if (!result.isConfirmed) return;

            // Logout API
            const res = await apiRequest({
                url: "admin/logout",
                method: "POST",
                data: {}
            }).unwrap();

            if (res?.success) {

                // Preserve theme
                const theme = localStorage.getItem("theme");

                // Clear local storage
                localStorage.clear();

                // Restore theme
                if (theme !== null) {
                    localStorage.setItem("theme", theme);
                }

                // Clear RTK Query cache
                dispatch(apiService.util.resetApiState());

                // Success notification
                ToastService.success(
                    res?.message || "Logged out successfully!"
                );

                // Redirect to login
                navigate("/", { replace: true });

            } else {

                ToastService.error(
                    res?.message || "Logout failed."
                );

            }

        } catch (error) {

            console.error("Logout error:", error);

            ToastService.error(
                error?.data?.message ||
                error?.data?.error?.message ||
                error?.message ||
                "Unable to logout. Please try again."
            );

        }

    }, [apiRequest, dispatch, navigate]);

    return {
        Logout,
        isLoggingOut: isLoading,
    };
};

export default useAdminLogout;

